import LOGO from "../images/Natalias.png";

export const Team__Natalias = {
  name: "Natalias",
  logoImage: LOGO,
  teamImage: null,
  teamLogoColor: "#111111",
  teamJerseyColor: "#222222",

  // Stats
  gamesWon: 1,
  gamesLost: 2,
  gamesTied: 0,
  gamesTiedWon: 0,

  ownGoalsInFavor: 34 + 18 + 32,
  goalsScoredAgainst: 37 + 16 + 33,
  defaultGoals: 0,

  isChampion: false,
  isEliminated: false,

  players: [],
};
